import PropTypes from 'prop-types';
import ClassicAlterListMembershipActionMetadata from 'automation-ui-action-features/deprecated/alter-list-membership/ClassicAlterListMembershipActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import ClassicAlterListMembershipActionDetail from 'automation-ui-action-features/deprecated/alter-list-membership/ClassicAlterListMembershipActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Powered by CLS instead of ILS. Prefer ALTER_LIST_MEMBERSHIP.
 * Keeping around for backwards compatibility.
 */
const ClassicAlterListMembershipActionHistoryCard = ({
  actionLabel,
  actionMetadata
}) => {
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsx(ClassicAlterListMembershipActionDetail, {
      actionMetadata: actionMetadata
    })
  });
};
ClassicAlterListMembershipActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicAlterListMembershipActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default ClassicAlterListMembershipActionHistoryCard;